export default {"src":"/_next/static/media/panIndia.eac52425.svg","height":160,"width":160};